import { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import Loader from "../../../Loader";
import EquifaxForm from "./EquifaxForm";
import { getServiceNameAndDetails } from "../../../Services";

export default function EquifaxCreditReportDashboard() {
      const [isLoading, setIsLoading] = useState(false);
       const endPoint = "/credit-report/equifax";
      const [serviceName, setServiceName] = useState("");

      

        useEffect(() => {
    const getServiceName = async () => {
      try {
        const res = await getServiceNameAndDetails({
          end_point: endPoint,
        });

        if (res?.status?.code === 200) {
          setServiceName(res?.data?.service_name);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getServiceName();
  }, []);

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="bg-gray-100 min-h-screen">
        <div className="max-w-7xl mx-auto space-y-6">

          <EquifaxForm
           />
        </div>
      </div>
    </>
  );
}
